import { isToday, isYesterday, startOfDay, subDays } from 'date-fns';
import {
    AIConvoHistoryGrouped,
    AIConvoHistoryItem,
} from '../models/ai-convo-history.model';

export function groupHistoryByDate(
    items: AIConvoHistoryItem[],
): AIConvoHistoryGrouped[] {
    if (items.length === 0) return [];

    const now = new Date();
    const startOf7DaysAgo = startOfDay(subDays(now, 7));

    const todayItems: AIConvoHistoryItem[] = [];
    const yesterdayItems: AIConvoHistoryItem[] = [];
    const recentItems: AIConvoHistoryItem[] = [];
    const olderItems: AIConvoHistoryItem[] = [];

    for (const item of items) {
        const ts = item.lastModifyTimestamp;
        if (isToday(ts)) {
            todayItems.push(item);
        } else if (isYesterday(ts)) {
            yesterdayItems.push(item);
        } else if (ts >= startOf7DaysAgo) {
            recentItems.push(item);
        } else {
            olderItems.push(item);
        }
    }

    const hasToday = todayItems.length > 0;
    const hasYesterday = yesterdayItems.length > 0;
    const hasLast7Days =
        yesterdayItems.length > 0 || recentItems.length > 0 || hasToday;

    // No conversations in the last 7 days → flat list, no grouping
    if (!hasLast7Days) {
        return [{ group: 'ungrouped', items: olderItems }];
    }

    const groups: AIConvoHistoryGrouped[] = [];

    if (hasToday) {
        groups.push({ group: 'today', items: todayItems });
        // "Ultimi 7 giorni" = yesterday + recent (everything non-today within 7 days)
        const last7 = [...yesterdayItems, ...recentItems];
        if (last7.length > 0) {
            groups.push({ group: 'last7days', items: last7 });
        }
    } else if (hasYesterday) {
        groups.push({ group: 'yesterday', items: yesterdayItems });
        // "Ultimi 7 giorni" = recent (excluding yesterday)
        if (recentItems.length > 0) {
            groups.push({ group: 'last7days', items: recentItems });
        }
    } else {
        // No today, no yesterday but has recent items
        groups.push({ group: 'last7days', items: recentItems });
    }

    if (olderItems.length > 0) {
        groups.push({ group: 'older', items: olderItems });
    }

    return groups;
}
